module.exports = __webpack_public_path__ + "fonts/VetoSans-Medium_1.e9a84dfe.woff2";